import React from "react";
import { Helmet } from "react-helmet";
import ErrorPage from "../../components/shared/ErrorPage";

const pageNotFound404 = ({ staticContext = {} }) => {
  staticContext.notFound = true;
  return (
    <React.Fragment>
      <Helmet title="Page not found" />
      <div className="errorPadContainer">
        <ErrorPage
          imageUrl="/assets/svg/logo404.svg"
          errorPageHeading="Oh no! Page not found."
          errorCode="Error code: 404"
          errorPageDescription="We couldn’t find the page you’re looking for. Either something went wrong, or that page doesn’t exist."
          linkUrl="/"
          linkText="Go home"
        />
      </div>
    </React.Fragment>
  );
};

export default {
  component: pageNotFound404
};
